import { Box, Button, IconButton, Menu, MenuItem, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { config, styles } from "../../style";
import BackupOutlinedIcon from "@mui/icons-material/BackupOutlined";
import CustomiseTable from "../../components/CustomiseTable";
import PdfIcon from "../../icons/PdfIcon";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MobileTableList from "../../components/MobileTableList";
import { post } from "../../api";
import { LoadingButton } from "@mui/lab";
import { faFile } from "@fortawesome/free-solid-svg-icons";

import { iconMapping } from "../../components/DocumentUpload/iconMapping";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const rowsData = [
    {
        fileName: "Mays.A.NorthropGrumman.RestonVA.9.11.2024.BP",
        fileType: "PDF",
        fileSize: "200 KB",
        dateUploaded: "Jan 4, 2022",
        uploadedBy: "Olivia Rhye",
    },
    {
        fileName: "Robles.A.TDSecuritiesInc.05.16.2024.CADD2S.ENG040",
        fileType: "PDF",
        fileSize: "200 KB",
        dateUploaded: "Jan 4, 2022",
        uploadedBy: "Olivia Rhye",
    },
    {
        fileName: "UX Design Guidelines.docx",
        fileType: "PDF",
        fileSize: "200 KB",
        dateUploaded: "Jan 4, 2022",
        uploadedBy: "Olivia Rhye",
    },
    {
        fileName: "Mays.A.NorthropGrumman.RestonVA.9.11.2024.BP",
        fileType: "PDF",
        fileSize: "200 KB",
        dateUploaded: "Jan 4, 2022",
        uploadedBy: "Olivia Rhye",
    },
];

function ShowFiles({ data }) {
    const fileToDownloadRef = React.useRef(null);
    const [downloading, setDownloading] = React.useState(false);

    const download = async (url, name) => {
        const a = document.createElement("a");
        a.href = url;
        a.download = name; // Fallback filename
        a.style.display = "none";
        document.body.appendChild(a);

        a.click();
        document.body.removeChild(a);
        setTimeout(() => {
            if (fileToDownloadRef.current?.length > 0) {
                let record = fileToDownloadRef.current?.pop();
                handleDocumentClick(record);
            } else {
                setDownloading(false);
            }
        }, 1000);
    };

    const getIcon = (extension) => {
        const icon = iconMapping[extension]?.icon;
        return icon ? icon : faFile;
    };

    const getColor = (extension) => {
        const color = iconMapping[extension]?.color;
        return color ? color : "#413ab4";
    };

    const handleDocumentClick = (docData) => {
        post("opportunity/getDocumentPublicLinks", { recordId: docData?.latestPublishedVersionId }).then((result) => {
            if (result.isSuccess) {
                download(result.data, docData.title + "." + docData.fileExtension);
            }
        });
    };

    const downloadAll = () => {
        fileToDownloadRef.current = [...data];
        if (data?.length > 0) {
            setDownloading(true);
            let record = fileToDownloadRef.current?.pop();
            handleDocumentClick(record);
        }

        // for (let record of data) {
        //     setTimeout(() => {
        //         handleDocumentClick(record);
        //     }, 1400);
        // }
    };

    const columnsData = [
        {
            fieldName: "title",
            name: "File name",
            hideCellValue: true,
            hideLeftCell: true,
            rightCellSx: {
                width: "100%",
            },
            renderElement: (row, currentValue) => {
                return (
                    <Box
                        display={"flex"}
                        justifyContent={{ xs: "space-between", sm: "start" }}
                        alignItems={"center"}
                        width={"100%"}>
                        <Box display={"flex"} alignItems={"center"}>
                            {/* <PdfIcon
                                sx={{
                                    width: {
                                        xs: "40px",
                                        sm: "32px",
                                    },
                                    height: {
                                        xs: "40px",
                                        sm: "32px",
                                    },
                                }}
                            /> */}
                            <FontAwesomeIcon
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    color: getColor(row.fileExtension),
                                }}
                                icon={getIcon(row.fileExtension)}
                            />
                            <Typography
                                component={"p"}
                                variant="paraText3"
                                fontSize={"15px"}
                                marginLeft={"0.5rem"}
                                sx={{
                                    //  overflow: "hidden",
                                    //  textOverflow: "ellipsis",
                                    //  whiteSpace: "nowrap",
                                    //  width:"200px"
                                    wordBreak: "break-all",
                                }}>
                                {currentValue}
                            </Typography>
                        </Box>
                        <Box
                            display={{
                                xs: "flex",
                                sm: "none",
                            }}>
                            <MoreButton onClick={() => handleDocumentClick(row)} />
                        </Box>
                    </Box>
                );
            },
        },
        {
            fieldName: "fileType",
            name: "File type",
            listItemRowSx: {
                width: "50%",
            },
        },
        {
            fieldName: "contentSize",
            name: "File size",
            listItemRowSx: {
                width: "50%",
            },
        },
        {
            fieldName: "createdDate",
            name: "Date uploaded",
        },
        {
            fieldName: "ownerName",
            name: "Uploaded by",
        },
        {
            fieldName: "more",
            hideCellValue: true,
            hideLeftCell: true,
            hideItem: true,
            onRowClickHandler: (row) => {},
            renderElement: (row, currentValue) => {
                return <MoreButton onClick={() => handleDocumentClick(row)} />;
            },
        },
    ];
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <Paper
            sx={{
                borderRadius: "8px",
                border: "1px solid #E9E9E9",
                background: "#FFF",
                overflow: "auto",
            }}>
            <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={{ xs: "start", sm: "center" }}
                flexDirection={{
                    xs: "column",
                    sm: "row",
                }}
                padding={{ xs: "16px", sm: "20px 24px" }}>
                <Typography
                    component={"span"}
                    variant="paraText1"
                    color={config.textPrimary}
                    fontWeight={"fontWeightMedium"}>
                    Files uploaded
                </Typography>
                <Box
                    display={"flex"}
                    alignItems={"center"}
                    marginTop={{
                        xs: "1rem",
                        sm: "0rem",
                    }}
                    width={{ xs: "100%", sm: "auto" }}>
                    <LoadingButton
                        variant="outlined"
                        onClick={downloadAll}
                        loading={downloading}
                        sx={{
                            ...styles.outlinedButton,
                            width: {
                                xs: "100%",
                                sm: "auto",
                            },
                            display: {
                                lg: "block",
                                xs: "none",
                            },
                        }}>
                        Download all
                    </LoadingButton>
                </Box>
            </Box>

            {!isMobileView ? (
                <CustomiseTable columns={columnsData} rows={data} onRowClickHandler={() => {}} />
            ) : (
                <MobileTableList columns={columnsData} rows={data} />
            )}
        </Paper>
    );
}

const MoreButton = ({ onClick }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event) => {
        event?.stopPropagation();
        event?.preventDefault();
        setAnchorEl(null);
    };
    return (
        <>
            <IconButton
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(event) => handleClick(event)}
                disableRipple={false}
                sx={{
                    color: "#98A2B3",
                    marginRight: { xs: "-16px", sm: "0" },
                }}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}>
                <MenuItem
                    onClick={(event) => {
                        onClick();
                        handleClose(event);
                    }}>
                    Download
                </MenuItem>
            </Menu>
        </>
    );
};

export default ShowFiles;
